const TZ = "Europe/Kyiv";

function kyivOffsetMs(ms) {
  const date = new Date(ms);
  const utcDate = new Date(date.toLocaleString("en-US", { timeZone: "UTC" }));
  const tzDate = new Date(date.toLocaleString("en-US", { timeZone: TZ }));
  return tzDate - utcDate;
}

export function kyivDayStartMs(dateObj) {
  const guess = Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());
  return guess - kyivOffsetMs(guess);
}

export function kyivTicks(startMs, count = 9, stepH = 3) {
  return Array.from({ length: count }, (_, i) => startMs + i * stepH * 3600 * 1000);
}

const hm = new Intl.DateTimeFormat("uk-UA", {
  timeZone: TZ,
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export function fmtKyivHM(ms) {
  return hm.format(new Date(ms));
}
